import { useNavigate } from 'react-router-dom';
import SMFooter from './SMFooter';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { Header } from '@deere/fuel-react/Header';
import {
  browserName,
  browserVersion,
  osName,
  osVersion
} from 'react-device-detect';

import { useUserInfo } from '../shared/UserInfo';
import { getContactUsLink } from '../shared/UtilFunctions';
import { DM_STRATEGY_MANAGEMENT } from '../shared/AppConstants';

export default function AppError(props) {
  const info = useUserInfo();
  const loggedInUser = info && info.userId;

  const errorInfo = props.errorInfo;

  const navigate = useNavigate();
  function goBack() {
    navigate('/');
    navigate(0);
  }

  const jdsnAppError = {
    errorMsg: 'Some unexpected application error has occurred!',
    user: loggedInUser,
    timestamp: new Date().toLocaleString(),
    opsystem: osName,
    osversion: osVersion,
    browser: browserName,
    appVersion: browserVersion,
    appURL: window.location.href,
    appErrorInfo: errorInfo && errorInfo.componentStack
  };

  const goHelpDesk = () =>
    window.open(getContactUsLink(loggedInUser, jdsnAppError.appErrorInfo));

  return (
    <>
      <Header
        applicationName={DM_STRATEGY_MANAGEMENT}
        slotProps={{ mobileMenu: { isHidden: true } }}
      />
      <Box
        component="main"
        id="content"
        sx={(theme) => ({
          width: '100%',
          paddingInline: theme.fuel6Tokens.JddcSpacingMedium,
          backgroundColor: theme.fuel6Tokens.JddcColorBackgroundSecondary,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        })}
      >
        <Typography component="h1" variant="h2">
          Sorry, there was an error!
        </Typography>
        <Box
          sx={{
            fontSize: '200px',
            color: (theme) => theme.fuel6Tokens.JddcColorIconSecondary
          }}
        ></Box>
        <fuel-icon name="warning" size="lg" />
        <Typography>{jdsnAppError.errorMsg}</Typography>
        <Box sx={(theme) => ({ py: theme.fuel6Tokens.JddcSpacingXLarge })}>
          <Button variant="secondary" onClick={goBack}>
            Go Back and Try Again
          </Button>
          <Button
            variant="primary"
            onClick={goHelpDesk}
            sx={{ marginLeft: '.5rem' }}
          >
            Contact Help Desk
          </Button>
        </Box>
        <Box
          component="p"
          sx={(theme) => ({ pt: theme.fuel6Tokens.JddcSpacingSmall })}
        >
          <span>Error Details</span>
          <br />
          {jdsnAppError.user}, {jdsnAppError.timestamp}, {jdsnAppError.opsystem}
          , {jdsnAppError.browser}
          <br />v{jdsnAppError.appVersion}, {jdsnAppError.appURL}
          <br />
          {jdsnAppError.appErrorInfo}
        </Box>
      </Box>
      <SMFooter />
    </>
  );
}
